import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRoleType } from '../models/crm-enums';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // 1. Get the roles required to access this route from the route's data property.
  const expectedRoles = route.data['expectedRoles'] as UserRoleType[];

  // 2. If no roles are specified on the route, it's a configuration error or public route.
  //    For safety, we should deny access if this guard is used without roles.
  if (!expectedRoles || expectedRoles.length === 0) {
    console.error('Role guard used without `expectedRoles` in route data.');
    router.navigate(['/dashboard']); // Redirect to a safe default page
    return false;
  }

  // 3. Check if the currently logged-in user has one of the required roles.
  const allowDepartmentHead = route.data['allowDepartmentHead'] === true;
  const hasPermission = authService.hasRole(expectedRoles) || (allowDepartmentHead && authService.isDepartmentHead());

  if (hasPermission) {
    return true; // Yes, the user has the required role. Allow access.
  }

  // 4. If the user does not have the role, deny access and redirect.
  console.warn('Access Denied: User does not have the required role.');
  router.navigate(['/dashboard']); // Redirect to a safe default page
  return false;
};